<template>
    <div v-if="isVisible" class="formsection w-100">
        <component
            :is="capitalize(section_item.data.view)"
            v-for="section_item in item.items"
            :key="section_item.data.id"
            :item="section_item"
            :values="values"
            :errors="errors"
            :answer-options="answerOptions"
            :form-values="formValues"
            @update-form-value="updateFormValue"
            />
    </div>
</template>

<script>
import Input from "./Input.vue";
import Button from "./Button.vue";
import Select from "./Select.vue";
import Radio from "./Radio.vue";
import Checkbox from "./Checkbox.vue";
import Html from "./Html.vue";
import Instruction from "./Instruction.vue";
import Terms from "./Terms.vue";
import Scale from "./Scale.vue";
import Numericscale from "./Numericscale.vue";
import File from "./File.vue";

import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";

import capitalize from "../../formeditor/util/capitalize";

export default {
    name: 'FormSection',
    components: {
        Input,
        Button,
        Select,
        Radio,
        Checkbox,
        Html,
        Instruction,
        Terms,
        Scale,
        Numericscale,
        File
    },
    mixins: [ errorMixin, logicMixin ],
    props: {
        item: {
            type: Object
        },
        answerOptions: {
            type: Object
        },
        formValues: {
            type: Object
        }
    },
    methods: {
        capitalize,
        updateFormValue(ident, value) {
            this.$emit('update-form-value', ident, value)
        }
    }
};
</script>